enum Log {
  PAID = "paid",
  VOIDED = "voided",
  REFUNDED = "refunded",
  UNFULFILLED = "unfulfilled",
  FULFILLED = "fulfilled",
  CLOSED = "closed",
  CANCELLED = "cancelled",
  OPEN = "open",
  READ = "read",
  PENDING = "pending",
  CREATED = "order-created",
  NOTE_CREATED = "created",
  UPDATED = "updated",
  DISPATCHED = "dispatched",
  MARKED_AS_FULFILLED = "marked_as_fulfilled",
  PACKED = "packed",
  READY_FOR_PICKUP = "ready_for_pickup",
  UNPACKED = "unpacked",
  DELIVERED = "delivered",
  REASON = "reason",
  ADD = "add",
  REMOVE = "remove",
  DISCOUNT_ADD = "discount-add",
  DISCOUNT_REMOVE = "discount-remove",
  REMOVE_STOCK = "remove-stock",
  SHIPPING_COST = "shipping-cost",
  SKIP_SHIPPING_REQUOTE = "skip-shipping-requote",
  TRANSACTION_INFO = "transaction-info",
  CF_ASSOCIATED = "custom_field_associated",
  NOTIFICATION = "notification",
  SHIPPING_ADDRESS_EDIT = "edited",
  AUTHORIZED = "authorized",
  INVOICE_ISSUED = "invoice-issued",
  INVOICE_UPDATED = "invoice-updated",
  INVOICE_CANCELLED = "invoice-cancelled",
  INVOICE_APPROVED = "invoice-approved",
  INVOICE_REJECTED = "invoice-rejected",
  EXPIRED = "expired",
}

export enum LogType {
  TRANSACTION = "transaction-event",
  FULFILLMENT = "order-fulfillment",
  FULFILLMENT_TRACKING_INFO_ADD = "order-fulfillment-tracking-info-add",
  FULFILLMENT_TRACKING_INFO_EDIT = "order-fulfillment-tracking-info-edit",
  EDIT = "order-edit",
  EDIT_SUB = "order-edit-sub",
  METAFIELDS = "order-custom-field-association",
  ORDER_PAYMENT = "order-payment",
  ORDER_INVOICE = "order-invoice",
  NEW_PAYMENT_ATTEMPT = "new-payment-attempt",
  PAYMENT_METHOD_CHANGE = "payment-method-change",
}

export default Log;
